import React, {useMemo, useState} from 'react';
import './LazyVideo.scss';

const getVideoMeta = (link) => {
    const rawLink = link || '';

    try {
        const url = new URL(rawLink);

        if (url.hostname.includes('youtube.com')) {
            const id = url.searchParams.get('v') || url.pathname.split('/').filter(Boolean).pop();
            return {
                id,
                provider: 'youtube',
                embedUrl: `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`,
                thumbUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
                externalUrl: rawLink
            };
        }

        if (url.hostname.includes('youtu.be')) {
            const id = url.pathname.split('/').filter(Boolean).pop();
            return {
                id,
                provider: 'youtube',
                embedUrl: `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`,
                thumbUrl: `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
                externalUrl: rawLink
            };
        }

        if (url.hostname.includes('vimeo.com')) {
            const id = url.pathname.split('/').filter(Boolean).pop();
            return {
                id,
                provider: 'vimeo',
                embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1`,
                thumbUrl: `https://vumbnail.com/${id}.jpg`,
                externalUrl: rawLink
            };
        }
    } catch (error) {
        return {
            id: rawLink,
            provider: 'unknown',
            embedUrl: rawLink,
            thumbUrl: '',
            externalUrl: rawLink
        };
    }

    return {
        id: rawLink,
        provider: 'unknown',
        embedUrl: rawLink,
        thumbUrl: '',
        externalUrl: rawLink
    };
};

const LazyVideo = (props) => {
    const {link, title = 'Video', className = ''} = props;
    const [isPlaying, setIsPlaying] = useState(false);
    const meta = useMemo(() => getVideoMeta(link), [link]);

    if (!meta.id) {
        return null;
    }

    return (
        <div className={`lazy-video ${className}`}>
            {isPlaying ? (
                <iframe
                    title={title}
                    src={meta.embedUrl}
                    loading="lazy"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            ) : (
                <button
                    type="button"
                    className="lazy-video__preview"
                    onClick={() => setIsPlaying(true)}
                    aria-label={`Play ${title}`}
                >
                    {meta.thumbUrl && (
                        <img
                            src={meta.thumbUrl}
                            alt=""
                            loading="lazy"
                            onError={(event) => {
                                event.currentTarget.style.display = 'none';
                            }}
                        />
                    )}
                    <span className="lazy-video__overlay" />
                    <span className="lazy-video__play" />
                </button>
            )}
        </div>
    );
};

export default LazyVideo;
